<template>
	<section id="modal_refuse_data">
		<div class="modal_box">
			<div class="modal_tit">반려내역</div>
			<div class="modal_close"></div>
			<div class="modal_inner">
				<form>
					<div class="refuseDate">
						<p>반려일시</p>
						<p id="bill_confirm_date">{{ commonjs.dateFormatYMDHis(props.refuseDate) }}</p>
					</div>
					<div class="refuseId">
						<p>반려자</p>
						<p id="bill_confirm_user">{{props.refuseName}}({{ props.refuseId }})</p>
					</div>
					<textarea placeholder="반려사유를 작성해주세요." id="bill_memo" v-html="props.refuseMemo"></textarea>
				</form>
				<div class="refuseBtnWrap">
					<div v-if="globaljs.acc_type === 'lab' && globaljs.mb_staff !== 'Worker'" class="btn_style1 publishBtn" id="publishBtn" @click="opener_goto_url(props.bill_id)">재발행</div>
					<div v-if="globaljs.acc_type === 'lab'" class="btn_style1 yes">확인</div>
					<div v-else class="btn_style1 yes" @click="opener_goto_url(props.bill_id)">상세</div>
				</div>
			</div>
		</div>
	</section>
	<div class="modal_bg"></div>
</template>

<script setup>
import { env as SERVER_URL } from '@/components/utils/env';
import { onMounted, ref, computed, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import * as globaljs from '@/components/utils/global';
import * as commonjs from '@/components/utils/common';

const router = useRouter();
const route = useRoute();

const opener_goto_url = (id) => {
	commonjs.billPopup(`/bill_view/${id}`);
	document.querySelector(".refuseBtnWrap .yes").click();
}

onMounted(async () => {
	//commonjs.DOMLoaded(); // 240912 중복으로 로드하면 문제라서 삭제
});

// Props
const props = defineProps({
	bill_id: {
		type: Number,
		required: false
	},
	refuseId: {
		type: String,
		required: false
	},
	refuseName: {
		type: String,
		required: false
	},
	refuseDate: {
		type: String,
		required: false
	},
	refuseMemo: {
		type: String,
		required: false
	},
});
</script>
